module.exports = __webpack_public_path__ + "806d6aea.jpg";